import "./Services.css"
import { Link } from "react-router-dom"

const Services = ({ showAll = false }) => {
  const mainServices = [
    {
      icon: "images/icon-7.png",
      title: "Orthopedic Surgery",
      description: "Comprehensive surgical solutions for bone and joint conditions",
    },
    {
      icon: "images/icon-5.png",
      title: "Sports Medicine",
      description: "Specialized care for sports-related injuries and performance",
    },
    {
      icon: "images/icon-6.png",
      title: "Joint Replacement",
      description: "Advanced joint replacement procedures for improved mobility",
    },
    {
      icon: "images/icon-7.png",
      title: "Trauma Surgery",
      description: "Emergency orthopedic trauma care and reconstruction",
    },
    {
      icon: "images/icon-5.png",
      title: "Knee and Shoulder Injection",
      description: "Therapeutic injections for pain relief and healing",
    },
    {
      icon: "images/icon-6.png",
      title: "Surgery for Cartilage Repair",
      description: "Innovative techniques for cartilage restoration",
    },
  ]

  return (
    <div className="services_section layout_padding" id="services">
      <div className="container">
        <div className="section-header">
          <h1 className="section_title">Surgeries Offered</h1>
          <p className="section_subtitle">Comprehensive orthopedic care with advanced surgical techniques</p>
        </div>

        <div className="services-grid">
          {mainServices.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <img src={service.icon || "/placeholder.svg"} alt={service.title} />
              </div>
              <h4 className="service-title">{service.title}</h4>
              {showAll && <p className="service-description">{service.description}</p>}
            </div>
          ))}
        </div>

        {showAll && (
          <>
            <div className="service-category">
              <h2 className="category-title">Knee Arthroscopic Surgery</h2>
              <div className="services-grid">
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-7.png" alt="ACL Reconstruction" />
                  </div>
                  <h4 className="service-title">ACL Reconstruction</h4>
                  <p className="service-description">Advanced techniques for anterior cruciate ligament repair</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-5.png" alt="Meniscal Repair" />
                  </div>
                  <h4 className="service-title">Meniscal Repair</h4>
                  <p className="service-description">Minimally invasive meniscus repair procedures</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-6.png" alt="PCL Reconstruction" />
                  </div>
                  <h4 className="service-title">PCL Reconstruction</h4>
                  <p className="service-description">Posterior cruciate ligament reconstruction surgery</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-7.png" alt="Multi-ligament Injuries" />
                  </div>
                  <h4 className="service-title">Multi-ligament Injuries</h4>
                  <p className="service-description">Complex ligament injury treatment and reconstruction</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-5.png" alt="Patella Dislocation" />
                  </div>
                  <h4 className="service-title">Patella Dislocation Surgery</h4>
                  <p className="service-description">Surgical correction for patellar instability</p>
                </div>
              </div>
            </div>

            <div className="service-category">
              <h2 className="category-title">Knee Surgery</h2>
              <div className="services-grid">
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-7.png" alt="Knee Trauma Surgery" />
                  </div>
                  <h4 className="service-title">Knee Trauma Surgery</h4>
                  <p className="service-description">Emergency and reconstructive knee trauma procedures</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-5.png" alt="Knee Replacement" />
                  </div>
                  <h4 className="service-title">Knee Replacement Surgery</h4>
                  <p className="service-description">Total and partial knee replacement procedures</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-6.png" alt="Computer Navigated Knee" />
                  </div>
                  <h4 className="service-title">Computer Navigated Knee Replacement</h4>
                  <p className="service-description">Precision-guided knee replacement technology</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-7.png" alt="Robotic Knee" />
                  </div>
                  <h4 className="service-title">Robotic Knee Replacement Surgery</h4>
                  <p className="service-description">State-of-the-art robotic-assisted knee surgery</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-5.png" alt="HTO" />
                  </div>
                  <h4 className="service-title">HTO</h4>
                  <p className="service-description">High tibial osteotomy for knee realignment</p>
                </div>
                <div className="service-card">
                  <div className="service-icon">
                    <img src="images/icon-6.png" alt="Patellar Dislocation Surgery" />
                  </div>
                  <h4 className="service-title">Surgery for Patellar Dislocation</h4>
                  <p className="service-description">Comprehensive patellar stabilization procedures</p>
                </div>
              </div>
            </div>

            <div className="service-category">
              <div className="row">
                <div className="col-lg-6">
                  <h2 className="category-title">Shoulder Arthroscopic Surgery</h2>
                  <div className="services-grid">
                    <div className="service-card">
                      <div className="service-icon">
                        <img src="images/icon-7.png" alt="Shoulder Dislocation" />
                      </div>
                      <h4 className="service-title">Surgery for Shoulder Dislocation</h4>
                      <p className="service-description">Arthroscopic shoulder stabilization procedures</p>
                    </div>
                    <div className="service-card">
                      <div className="service-icon">
                        <img src="images/icon-5.png" alt="Rotator Cuff Repair" />
                      </div>
                      <h4 className="service-title">Rotator Cuff Repair</h4>
                      <p className="service-description">Minimally invasive rotator cuff reconstruction</p>
                    </div>
                    <div className="service-card">
                      <div className="service-icon">
                        <img src="images/icon-6.png" alt="Biceps Surgery" />
                      </div>
                      <h4 className="service-title">Biceps Surgery</h4>
                      <p className="service-description">Biceps tendon repair and reconstruction</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <h2 className="category-title">Shoulder Surgery</h2>
                  <div className="services-grid">
                    <div className="service-card">
                      <div className="service-icon">
                        <img src="images/icon-7.png" alt="Shoulder Trauma" />
                      </div>
                      <h4 className="service-title">Shoulder Trauma Surgery</h4>
                      <p className="service-description">Comprehensive shoulder trauma care</p>
                    </div>
                    <div className="service-card">
                      <div className="service-icon">
                        <img src="images/icon-5.png" alt="Total Shoulder Replacement" />
                      </div>
                      <h4 className="service-title">Total Shoulder Replacement</h4>
                      <p className="service-description">Complete shoulder joint replacement</p>
                    </div>
                    <div className="service-card">
                      <div className="service-icon">
                        <img src="images/icon-6.png" alt="Reverse Shoulder" />
                      </div>
                      <h4 className="service-title">Reverse Shoulder Replacement</h4>
                      <p className="service-description">Advanced reverse shoulder arthroplasty</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {!showAll && (
          <div className="text-center mt-5">
            <Link to="/services" className="btn btn-view-more">
              View All Services
              <i className="fa fa-arrow-right ms-2"></i>
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default Services
